import { type Location, matchPath, type PathMatch } from "react-router";

// list of context path where we need the view to sustain in the URL
const sustainableViewContextPath: string[] = [
  // MIND THE ORDER!
  // A more complex context must be placed before sub-contexts in order to have precedence (we do inexact matching)!
  //
  // [SEL6-2348] Do not sustain the view ID if loading a view of a genome viewer and then changing the genome.
  // We do NOT need this for the other entities because there you can't break out of the genome context in the genome viewer.
  // The only problem is that switching from "/variant/:variantId/genome/:genomeId" to another summary page of this variant will NOT sustain the viewId.
  // this is a TEMPORARY workaround until we tackle User Story [SEL6-2272]
  "/variant/:variantId/genome/:genomeId",
  //
  "/job/:id",
  "/content/organisms", // was "/content/:featureType", but this is too generic and also covers the parent tables
  "/gene/:geneId",
  "/protein/:proteinId",
  "/transcript/:transcriptId",
  "/contig/:contigId",
  "/sequence/:sequenceId",
  "/organism/:genomeId",
  "/variant/:variantId",
  "/sample/:sampleId",
  "/parent/:parentId",
  "/marker/:markerId",
  "/nuFeature/:nuFeatureId",
  "/search/:searchResultId",
  "/visualizer/data/group/:groupId",
  "/visualizer/data/dataset/:datasetId",
  "/visualizer/genome/:genomeId",
];

// return the match (return of react-router's matchPath) between the next location and any of the {sustainableViewContextPath} above
export function viewContextPathMatch(location: Location): PathMatch | null {
  let match = null;
  sustainableViewContextPath.some((viewContext: string) => {
    const currentMatch = matchPath({ path: viewContext, end: false }, location.pathname);

    // Special case: exclude /organism/:genomeId/coordinates from sustaining the view context.
    // Since we dynamically add new tracks and don't want to update the view in the DB we step out from the view context
    if (currentMatch && viewContext === "/organism/:genomeId") {
      const coordinatesMatch = matchPath({ path: "/organism/:genomeId/coordinates", end: false }, location.pathname);
      if (coordinatesMatch) {
        return false; // continue to next iteration, skip this match
      }
    }

    if (currentMatch) {
      match = currentMatch;
      return true; // break out of loop
    }

    return false; // continue to next iteration
  });
  return match;
}
